<template>
  <div class="home-over-btn">
    <router-link
      :to="{ name: 'kpi.home', query: { activity_id: activity_id, user_id: user_id, kpi_uid: kpi_userid, share_uid: share_userid,act_id: act_id }}"
    >
      <img src="https://j.weizan.cn/youxiang/images/home-over.png" />
      首页
    </router-link>
  </div>
</template>
<script>
export default {
  props: ["activity_id", "user_id", "kpi_userid", "share_userid"],
  data() {
    return {
      act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
    };
  },
};
</script>